import React from 'react';
import { motion } from 'framer-motion';
import '../Style/Footer.css';

const Footer = () => {
  return (
    <motion.footer 
      className="footer"
      initial={{ opacity: 0, y: 50 }} 
      animate={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.8 }}
    >
      <div className="footer-content">
        <motion.p 
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        >
          &copy; 2025 Pâtichmie. Tous droits réservés.
        </motion.p>
        
        <motion.div 
          className="legal-notice"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <p>
            <strong>Mentions légales :</strong>
          </p>
          <p>
            <strong>Email :</strong> <a href="mailto:patichmie@outlook.fr">patichmie@outlook.fr</a>
          </p>
          <p>
            <strong>Hébergeur :</strong> Hostinger International Ltd., 61 Lordou Vironos, 6023 Larnaca, Chypre
          </p>
          <p>
            <strong>Crédits :</strong> Ce site inclut un lien vers <a href="https://ptable.com/" target="_blank" rel="noopener noreferrer">Ptable®</a>, une marque déposée de Michael Dayah, accessible à des fins éducatives.
          </p>
          <p>
            <em>Ce site est à vocation ludique et éducative. Des erreurs peuvent apparaître et sont à considérer comme des approximations.</em>
          </p>
        </motion.div>
        
        <motion.div 
          className="footer-links"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          <p>
            <motion.a 
              href="/privacy-policy"
              whileHover={{ scale: 1.1, color: "#ff6f61" }}
              transition={{ duration: 0.3 }}
            >
              Politique de confidentialité
            </motion.a>
            {' | '}
            <motion.a 
              href="/terms-of-service"
              whileHover={{ scale: 1.1, color: "#ff6f61" }}
              transition={{ duration: 0.3 }}
            >
              Conditions d'utilisation
            </motion.a>
          </p>
        </motion.div>
      </div>
    </motion.footer>
  );
}

export default Footer;
